export const spaceClassGeneration = (props, prefix) => {
    let classes = [];
    const { space, left, right, top, bottom } = props;
    if (space)
        classes.push(`${prefix}-${space}`);
    if (left)
        classes.push(`${prefix}-left-${left}`);
    if (right)
        classes.push(`${prefix}-right-${right}`);
    if (top)
        classes.push(`${prefix}-top-${top}`);
    if (bottom)
        classes.push(`${prefix}-bottom-${bottom}`);
    return classes;
};
